
import moment from 'moment';

export const helper_pdf = {
    get_structure:function(base64_img,appointment,client,employee,helper){
        let table = {
            style:['primaryColor','size11'],
            table:{
                heights: 20,
                widths: ['16.6%','16.6%','16.6%','16.6%','16.6%','16.6%'],
                body:[
                    [
                        {colSpan:2,rowSpan: 2, stack:[{image:base64_img, width: 160}],border:[true,true,false,true]},'',
                        {colSpan:2,rowSpan: 2, style:'size8',border:[false,true,false,true],text:" 206, Triq il-Kappillan Misfud,\nSt. Venera SVR 1852, Malta.\nTel: (+356) 21230777 - 21230778\nFax: (+356) 21230779\ne-mail: info@casmalta.com\nwebsite: www.casmalta.com\nVat. No. MT 1117-6001\nCo. Registration No: C19675"},'',
                        {colSpan:2, style:'size11',border:[false,true,true,false],text:" Specialising in Air-Conditioning\n& Central Heating\nRepairs - Sales - Service",alignment:'right'},''
                        //{colSpan:2,border:[false,true,true,false],style:'size8',text:' Specialising in Air-Conditioning\n& Central Heating\nRepairs - Sales - Service',alignment:'right'},''
                    ],
                    [
                        '','','','',{colSpan:2,border:[false,false,true,true],text:'JOB CARD N. '+appointment.id_appointment,alignment:'right'},''
                    ],
                    [
                        {text:'CLIENT:',border:[true,true,false,false]},
                        {colSpan:2,text: client.first_name+' '+client.last_name,border:[false,true,true,false]},'',
                        {colSpan:3,text: 'DATE: '+moment(appointment._created_at).format('DD/MM/YYYY')},'',''
                    ],
                    [
                        {rowSpan:4,text:'ADDRESS:',border:[true,false,false,false]},
                        {colSpan:2,rowSpan:4,border:[false,false,true,false],text:appointment.address},'',
                        {text:'INV. N.',colSpan:2},'',{text:'SOP. N.'}
                    ],
                    [
                        {text:''},
                        {colSpan:2,text:''},'',
                        {colSpan:3,text:'QUOTE N.:'},'',''
                    ],
                    [
                        {text:''},
                        {colSpan:2,text:''},'',
                        {colSpan:3,text:'PRICE:'},'',''
                    ],
                    [
                        {text:''},
                        {colSpan:2,text:''},'',
                        {colSpan:3,text:'PAYMENT:  \uf046 UG  \uf046 CREDIT \uf046 CASH'},'',''
                    ],
                    [
                        {text: 'TEL. N.: ',border:[true,false,false,true]},
                        {colSpan:2,border:[false,false,true,true],text:client.telephone_number},'',
                        {colSpan:3,text: 'APP.: '+moment(appointment.date).format('DD/MM/YYYY')+' '+appointment.time},'',''
                    ],
                    [
                        {colSpan:4,rowSpan:4,text: 'SUBJECT: '+appointment.detail},'','','',
                        {colSpan:2,rowSpan:4,text: 'DATE/TIME:'},''
                    ],
                    [
                        '','','','','',''
                    ],
                    [
                        '','','','','',''
                    ],
                    [
                        '','','','','',''
                    ],
                    [
                        {text:'MODEL'},{text:'INTERNAL S/N'},{text:'EXTERNAL S/N'},{text:'MODEL'},{text:'INTERNAL S/N'},{text:'EXTERNAL S/N'}
                    ],
                    [
                        {text:''},{text:''},{text:''},{text:''},{text:''},{text:''}
                    ],
                    [
                        {text:''},{text:''},{text:''},{text:''},{text:''},{text:''}
                    ],
                    [{
                        
                            table: {
                                widths: ['100%'],
                                heights: 20,
                                body: [
                                    [{text:'ACTION TAKEN:',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}]
                                ]
                            },
                            colSpan:6
                        
                    }],
                    [
                        {
                            colSpan:3,
                            border:[true,false,false,false],
                            table: {
                                widths: ['100%'],
                                heights: 20,
                                body: [
                                    [{text:'MATERIAL USED:',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}]
                                ]
                            }
                        },'','',
                        {
                            colSpan:3,
                            table: {
                                widths: ['100%'],
                                heights: 20,
                                body: [
                                    [{text:'TECH. SIGNATURE:',border:[false,false,false,true]}],
                                    [{text:'NAME IN BLKS:',border:[false,false,false,true]}],
                                    [{text:'ASSISTAN NAME:',border:[false,false,false,true]}]
                                ]
                            }
                        },'','',
                        //{colSpan:3,text:'TECH. SIGNATURE:'},'',''
                    ],
                    [
                        {
                            colSpan:3,
                            border:[true,false,false,false],
                            table: {
                                widths: ['100%'],
                                heights: 15,
                                body: [
                                    [{text:'',border:[false,false,false,true]}]
                                ]
                            }
                        },'','',
                        {colSpan:3,text:'DATE OF COMPLETATION:'},'',''
                    ],
                    [
                        {
                            colSpan:3,
                            border:[true,false,false,false],
                            table: {
                                widths: ['100%'],
                                heights: 15,
                                body: [
                                    [{text:'',border:[false,false,false,true]}]
                                ]
                            }
                        },'','',
                        {text:'AMOUNT RECEIVED:'},{text:'',colSpan:2},''
                    ],
                    /*[
                        {colSpan:3,rowSpan:5,text:'MATERIAL USED:'},'','',
                        {colSpan:3,text:'TECH. SIGNATURE:'},'',''
                    ],*/
                    /*[
                        {
                            table:{
                                widths: ['100%'],
                                heights: 20,
                                body: [
                                    ['hello']
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}],
                                    [{text:'',border:[false,false,false,true]}]
                                ]
                            },
                            colSpan:3
                        },
                        {colSpan:3,text:'TECH. SIGNATURE:'},'',''
                    ],*/
                    /*[
                        {colSpan:3,text:''},'','',
                        {colSpan:3,text:'NAME IN BLKS: '+employee.first_name+' '+employee.last_name},'',''
                    ],*/
                    /*[
                        {colSpan:3,text:''},'','',
                        {colSpan:3,text:'ASSISTANT NAME: '+helper},'',''
                    ],
                    [
                        {colSpan:3,text:''},'','',
                        {colSpan:3,text:'DATE OF COMPLETATION:'},'',''
                    ],
                    [
                        {colSpan:3,text:''},'','',
                        {colSpan:3,text:'AMOUNT RECEIVED: €'},'',''
                    ],
        */
                    [
                        {colSpan:3,text:'INVOICE TOTAL: €'},'','',
                        {colSpan:3,rowSpan:2,style:'size8',border:[true,true,true,false],text:"I, THE UNDERSIGNED, CONFIRM THAT THE ABOVE WORWS HAVE BEEN CARRIED OUT/DELIVERED/INSTALLED AND WORKING TO MY ENTIRE SATISFACTION."},'',''
                    ],
                    [
                        {colSpan:3,text:'GUARANTEE: TERMS CONDITIONS APPLY\n\uf046LABOUR   \uf046PARTS   \uf046COMPRESSOR'},'','',
                        '','',''
                    ],
                    [
                        {colSpan:3,style:'size5',text:'FAILURE TO SHOW THIS JOB CARD WILL RESULT IN THE LOSS OF COVER FOR THAT PARTICULAR JOB.\nGOODS NOT COLLECTED AFTER 30 (THIRTY DAYS FROM POINT OF NOTIFICATION WILL BECOME PROPERTY OF CAS LTD. CLIENT WILL FORFEIT ANY RIGHT OF OWNERSHIP ON THE UNIT.'},'','',
                        {colSpan:3,text:"CLIENT'S SIGNATURE:\n\nNAME IN BLKS:",border:[true,false,true,true]},'',''
                    ]
                ]
            }
        }

        return table;
    },

    get_style:function(){
        return {
            primaryColor:{
                color:'#00006D'
            },
            size5:{
                fontSize:5
            },
            size8:{
                fontSize: 8
            },
            size11:{
                fontSize: 11
            },
            minHeight:{
                height:10
            }
        }
    }
}
